import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-38-vikramadithya-guest.webp";
import ThumbImg from "../../assets/images/conversations/038.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: ab-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .ab-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .ab-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .ab-hero { padding-top: 60px; padding-bottom: 60px; }
  .ab-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .ab-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .ab-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ab-hero__title.ab-visible { opacity: 1; transform: translateY(0); }
  .ab-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .ab-hero__spotify.ab-visible { opacity: 1; transform: translateY(0); }
  .ab-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .ab-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .ab-hero__right.ab-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .ab-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .ab-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .ab-yt-thumb:hover img { opacity: 0.85; }
  .ab-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .ab-yt-thumb__play img { width: 40px; height: 44px; }
  .ab-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .ab-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .ab-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ab-body.ab-visible { opacity: 1; transform: translateY(0); }
  .ab-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .ab-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .ab-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ab-guest.ab-visible { opacity: 1; transform: translateY(0); }
  .ab-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .ab-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .ab-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .ab-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .ab-inner { padding-left: 32px; padding-right: 32px; }
    .ab-hero { padding-top: 32px; padding-bottom: 48px; }
    .ab-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .ab-hero__title { font-size: 24px; }
    .ab-hero__left { gap: 16px; }
    .ab-guest__title { font-size: 24px; margin-bottom: 24px; }
    .ab-guest__photo-bg { width: 260px; height: 300px; }
    .ab-guest__name { font-size: 24px; margin-top: 18px; }
    .ab-body__para { font-size: 14px; margin-bottom: 12px; }
    .ab-body { padding-bottom: 48px; }
    .ab-guest { padding-bottom: 48px; }
    .ab-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .ab-inner { padding-left: 16px; padding-right: 16px; }
    .ab-hero { padding-top: 51px; padding-bottom: 30px; }
    .ab-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .ab-hero__left { gap: 30px; }
    .ab-hero__title { font-size: 30px; }
    .ab-body__para { font-size: 16px; margin-bottom: 10px; }
    .ab-guest__title { font-size: 30px; margin-bottom: 20px; }
    .ab-guest__photo-bg { width: 100%; height: 386px; }
    .ab-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .ab-body { padding-bottom: 30px; }
    .ab-guest { padding-bottom: 30px; }
    .ab-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ab-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="ab-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 38 Amara Raja Batteries"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="ab-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 38 Amara Raja Batteries thumbnail" />
      <div className="ab-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="ab-hero">
      <div className="ab-inner">
        <div className="ab-hero__grid">
          <div className="ab-hero__left">
            <h1 ref={titleRef} className="ab-hero__title">
              EP 38 | Taking the bull by the horns, legacy takes the future head on | Amara Raja Batteries
            </h1>
            <div ref={spotifyRef} className="ab-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/76Yno8symGxlhzWdfTKnjd?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 38 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="ab-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="ab-body">
      <div className="ab-inner">
        <p className="ab-body__para">
          The EV revolution that we are witnessing globally right now has demonstrated that legacy players have been repeatedly caught off guard as new technologies were adopted earlier than they had anticipated. Whilst General Motors and Ford were sleeping, Tesla changed how people drive in America. Legacy car makers globally, even the super green European ones, had to be dragged kicking and screaming into the clean mobility era, more than 10 years after Tesla launched their first commercial car. In most sub-sectors within the clean mobility sector, the same pattern is evident as well. Legacy lead acid battery makers stood on the sidelines as CATL, Panasonic, and a myriad of other small startup companies led the race in lithium-ion battery adoption globally. Typically, legacy players have waited because they did not understand the technology and decided to move only when new technology started to become a threat to their existing business. But in this brave new world, that might be just waiting too long and being caught in the pincers of a Kodak or a Xerox moment. In this episode, we deep dive into the battery sector to understand why this pattern of legacy players taking their time keeps repeating itself. We speak to one of the big daddies of the battery world in India, who also dominates their sector in many of the countries they export to, and who, unlike most legacy players, is moving fast to learn, adopt, and dominate the new technology wins that are raging across their business. Today, we welcome the Executive Director of Amara Raja Batteries, Vikramadithya Gourineni, on this deep-dive journey.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="ab-guest">
      <div className="ab-inner">
        <h2 className="ab-guest__title">Our Guest</h2>
        <div>
          <div className="ab-guest__photo-bg">
            <img src={GuestImg} alt="Vikramadithya" />
          </div>
          <p className="ab-guest__name">Vikramadithya</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep38AmaraRajaBatteries() {
  return (
    <>
      <style>{CSS}</style>
      <div className="ab-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}